import { useNavigate } from "react-router";

import {
  IconButton,
  TableCell,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";
import { Pencil } from "lucide-react";

import useLocales from "@hooks/useLocales";
import usePermissions from "@hooks/usePermissions";
import { PATH_PROCUREMENT } from "@routes/paths";
import { fDateTime } from "@utils/formatTime";
import { isStandardizationOn } from "@utils/standardPermissions";

import { Permissions } from "src/@types/permissions";
import { IPurchaseOrderListItem } from "../../types/purchaseOrderTypes";

interface IPurchaseOrderDraftTableRowProps {
  row: IPurchaseOrderListItem;
}

export const PurchaseOrderDraftTableRow: React.FC<
  IPurchaseOrderDraftTableRowProps
> = ({ row }) => {
  const { translate } = useLocales();
  const { permissionHandle } = usePermissions();
  const { palette } = useTheme();
  const navigate = useNavigate();
  // Standardization: editing a PO draft needs Procurement_PurchaseOrder_Create
  const canEditDraft =
    !isStandardizationOn() ||
    permissionHandle([Permissions.Procurement_PurchaseOrder_Create]);

  const handleEdit = () => {
    navigate(
      `${PATH_PROCUREMENT.general.purchaseOrder.general.purchaseOrderCreate}?draftDocId=${row.id}`,
    );
  };

  return (
    <TableRow>
      <TableCell align="left">{row.poNumber ?? "-"}</TableCell>
      <TableCell align="left">{row.vendorCompanyName ?? "-"}</TableCell>
      <TableCell align="left">{row.customerCompanyName ?? "-"}</TableCell>
      <TableCell align="left">
        {row.createdDate ? fDateTime(row.createdDate) : "-"}
        {row.updatedDate && (
          <Typography variant="body2" color={palette.text.label}>
            {`${translate("last_updated")} ${fDateTime(row.updatedDate)}`}
          </Typography>
        )}
      </TableCell>
      <TableCell align="right">
        <IconButton onClick={handleEdit} disabled={!canEditDraft}>
          <Pencil size={18} />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};
